export const contractCreateRouter = [
  {
    path: "/signatures/contract-create/list",
    name: "signatures-contract-create",
    meta: { title: "创建合同" },
    component: () => import("@/views/signatures/contract-create/list/index.vue"),
  },
  {
    path: "/signatures/contract-create/detail/:id",
    name: "signatures-contract-detail",
    meta: { title: "合同详情" },
    component: () => import("@/views/signatures/contract-create/detail/detail.vue"),
  },
];
